import { ModifierList, PriceMoney, Variation } from "@/modules/location";
import {
  CategoryItemsInterface,
  ModifierListInterface,
  PriceInterface,
  SummaryItemInterface,
  VariationInterface,
} from "@/interface/business/item.interface";
import { ModifierListType, SummaryItemType, VariationType } from "@/types/business/item.type";

// @ts-ignore
import defaultItemImage from "@/assets/images/default-item-image.svg";
import { NAME_LOCAL_NAME_KEY } from "@/enums/orders.enum";
import ItemCategory from "@/modules/location/category";
import store from "@/store";

/**
 * SummaryItem Class
 * @param {SummaryItemInterface} Item
 */
export default class SummaryItem implements SummaryItemInterface {
  id: string = "";
  name: string = "";
  local_name?: string;
  price?: string;
  image?: string = "";
  category?: CategoryItemsInterface;
  quantity: number = 0;
  total_price: string = "";
  variation?: VariationInterface;
  variations?: Array<VariationType> = [];
  total_money?: PriceInterface;
  modifier_lists?: Array<ModifierListInterface>;

  constructor(data: SummaryItemType, isDigitalMenu: boolean = false) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.local_name = data.local_name || "";
    this.image = data.image || undefined;
    if (data?.category) {
      this.category = new ItemCategory(data?.category);
    }

    this.quantity = data.quantity || 0;
    this.prepareAmountValue(data);
    this.prepareTotalPrice(data);

    if (data?.variation) {
      this.variation = new Variation(data?.variation);
    }

    if (data.total_money) {
      this.total_money = new PriceMoney({ amount: data?.total_money?.amount });
    }

    // Where is the digital menu activated
    if (isDigitalMenu) {
      this.setupModifierList(data);
      this.variations = data?.variations || [];
    }
  }

  /***
   * Setup the Modifiers for Digital Menu Only
   * @param data
   * @private
   */
  private setupModifierList(data): any {
    const modifier_lists = data?.origin?.modifier_lists || data.modifier_lists || data.modifier_list;

    this.modifier_lists = modifier_lists?.map(
      (list: ModifierListType): ModifierListInterface => new ModifierList(list)
    );

    // setup the selected modifiers from sale
    if (!!data?.modifiers) {
      this.modifier_lists = this.modifier_lists?.map((list) => {
        list.modifiers = list.modifiers.map((modifier) => {
          const index = data?.modifiers.findIndex((mod) => mod.id === modifier.id);
          if (index > -1) {
            modifier.select();
          } else {
            modifier.unSelect();
            modifier.quantity = 0;
          }
          return modifier;
        });
        return list;
      });
    }
  }

  /**
   * prepare amount value
   * @param data
   * @private
   */
  private prepareAmountValue(data) {
    this.price =
      !!data.price && isNaN(data.price)
        ? data.price
        : new PriceMoney({ amount: data.price || data.variations?.[0]?.price_money?.amount || 0 }).getPricePackage();
  }

  /**
   * Calculate total price for each item , item price multiplied in quantity .
   * @param data
   * @private
   */
  private prepareTotalPrice(data) {
    this.total_price = new PriceMoney({ amount: this.quantity * data.price }).getPricePackage();
  }

  /**
   * get item name by language key
   * @return {string}
   */
  public getDisplayName(): string {
    const { state } = <any>store;
    return this?.[NAME_LOCAL_NAME_KEY[state.App.lang]] || this.name;
  }

  /**
   * get item image
   * @return {string}
   */
  public getDisplayImage(): string {
    return this.image?.["256"] || defaultItemImage;
  }
}
